export const API_HOST_ERROR_MESSAGE = "API host error";
export const SERVER_ERROR_MESSAGE = "Server Error";
